import { lazy } from '../../shared/deployment';

export const MembershipOverview = lazy(() => import('./ui/MembershipOverviewAdapter'));
export const JMTMembershipBenefits = lazy(() => import('./ui/MembershipBenefits'));
export const Init = lazy(() => import('./ui/Init'));

export { SET_MEMBERSHIP_OVERVIEW } from './model/slice';
export { MODULE_NAME } from './model/constants';
